import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const VLOPSubscriptionCard = ({ subscription, onUpdateStatus, onManageFeed }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'text-success bg-success/10';
      case 'pending': return 'text-warning bg-warning/10';
      case 'error': return 'text-error bg-error/10';
      case 'suspended': return 'text-muted-foreground bg-muted';
      default: return 'text-muted-foreground bg-muted';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'active': return 'CheckCircle';
      case 'pending': return 'Clock';
      case 'error': return 'AlertCircle';
      case 'suspended': return 'PauseCircle';
      default: return 'Circle';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-soft transition-smooth">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="Link" size={24} className="text-primary" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">{subscription?.platformName}</h3>
            <p className="text-sm text-muted-foreground">{subscription?.endpoint}</p>
          </div>
        </div>
        <div className={`flex items-center space-x-2 px-3 py-1 rounded-full text-sm font-medium ${getStatusColor(subscription?.status)}`}>
          <Icon name={getStatusIcon(subscription?.status)} size={16} />
          <span className="capitalize">{subscription?.status}</span>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
        <div className="text-center">
          <div className="text-2xl font-bold text-foreground">{subscription?.verdictsSent}</div>
          <div className="text-xs text-muted-foreground">Verdicts Sent</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-success">{subscription?.successRate}%</div>
          <div className="text-xs text-muted-foreground">Success Rate</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-warning">{subscription?.pendingActions}</div>
          <div className="text-xs text-muted-foreground">Pending</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-muted-foreground">{subscription?.lastSync}</div>
          <div className="text-xs text-muted-foreground">Hours Ago</div>
        </div>
      </div>
      {isExpanded && (
        <div className="border-t border-border pt-4 mb-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <h4 className="text-sm font-medium text-foreground mb-2">Feed Configuration</h4>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-muted-foreground">Content Types:</span>
                  <span className="text-foreground">{subscription?.contentTypes?.join(', ')}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">Languages:</span>
                  <span className="text-foreground">{subscription?.languages?.join(', ')}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">Priority Level:</span>
                  <span className="text-foreground capitalize">{subscription?.priority}</span>
                </div>
              </div>
            </div>
            <div>
              <h4 className="text-sm font-medium text-foreground mb-2">Compliance Status</h4>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-muted-foreground">DSA Compliance:</span>
                  <span className={`font-medium ${subscription?.dsaCompliant ? 'text-success' : 'text-error'}`}>
                    {subscription?.dsaCompliant ? 'Compliant' : 'Non-compliant'}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">Last Audit:</span>
                  <span className="text-foreground">{subscription?.lastAudit}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">Response Time:</span>
                  <span className="text-foreground">{subscription?.avgResponseTime}ms</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="flex items-center justify-between">
        <Button
          variant="ghost"
          size="sm"
          iconName={isExpanded ? "ChevronUp" : "ChevronDown"}
          iconPosition="right"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? 'Less Details' : 'More Details'}
        </Button>
        <div className="flex space-x-2">
          <Button
            variant="outline"
            size="sm"
            iconName="Settings"
            onClick={() => onManageFeed(subscription?.id)}
          >
            Manage Feed
          </Button>
          <Button
            variant="default"
            size="sm"
            iconName="Send"
            onClick={() => onUpdateStatus(subscription?.id)}
          >
            Test Connection
          </Button>
        </div>
      </div>
    </div>
  );
};

export default VLOPSubscriptionCard;